import { IconBaseProps } from "react-icons";
import {
  FaHeadset,
  FaQuestion,
  FaUser,
  FaUserDoctor,
  FaUserGear,
  FaUserNurse,
  FaUserTie,
} from "react-icons/fa6";
import { TbBuildingHospital } from "react-icons/tb";

export const UserType = {
  patient: "Patient",
  doctor: "Docteur",
  assistant: "Infirmier",
  midwife: "Sage-femme",
  organization: "Organisation",
};

export const UserTypeIcon = {
  patient: FaUser,
  doctor: FaUserDoctor,
  assistant: FaUserNurse,
  midwife: FaUserNurse,
  organization: TbBuildingHospital,
  dispatchOperator: FaHeadset,
  dispatchManager: FaUserTie,
  admin: FaUserGear,
  DEFAULT: FaQuestion,
};
